class EmbededFormController {

     constructor() {
          this.stylingClassName = 'is-fading';
          this.embededForms = null;
          this.miniCart = null;
          this.mobileMenudrawer = null;
          this.drawers = [];
          this.awaitEmbededForms();
     }

     embededFormCallback = (mutationsList, observer) => {
          for (const mutation of mutationsList) {
               if (mutation.addedNodes.length) {
                    const embededForms = document.querySelectorAll("shopify-forms-embed");
                    if (embededForms && embededForms.length > 0) {
                         this.embededForms = embededForms;
                         this.miniCart = document.querySelector("#mini-cart");
                         this.mobileMenudrawer = document.querySelector("#mobile-menu-drawer");
                         this.drawers = [this.miniCart, this.mobileMenudrawer];
                         this.awaitDrawerOpen();
                         observer.disconnect();
                         break;
                    }
               }
          }
     }

     awaitEmbededForms = () => {
          this.embededFormObserver = new MutationObserver(this.embededFormCallback);
          this.embededFormObserver.observe(document.body, { childList: true, subtree: true });
     }

     drawerCallback = (mutationsList, observer) => {
          for (const mutation of mutationsList) {
               if (mutation.type === 'attributes') {
                    this.fadingToggle(mutation);
               }
          }
     }

     fadingToggle = (mutation) => {
          if (mutation.attributeName === 'open') {
               const drawerSituationList = this.drawers.map(d=>{return d.hasAttribute('open')});
               const isAllFalse = drawerSituationList.every(val => !val); 
               isAllFalse?this.makeEmbededFormFadeIn(this.embededForms):this.makeEmbededFormFadeOut(this.embededForms);
          }
     }

     makeEmbededFormFadeOut = (forms) => {
          forms.forEach(form => {
               form.classList.add(this.stylingClassName);
          });
     }

     makeEmbededFormFadeIn = (forms) => {
          forms.forEach(form => {
               form.classList.remove(this.stylingClassName);
          });
     }

     drawerObservingWrapper = (listener, element) => {
          listener.observe(element, {
               attributes: true,
               attributeFilter: ['open']
          });
     }

     awaitDrawerOpen = () => {
          const drawerListener = new MutationObserver(this.drawerCallback);
          this.drawers.forEach(e=>{this.drawerObservingWrapper(drawerListener,e);})
     }
}

const efc = new EmbededFormController();